/**
 * Notify the app that a request returned 401 Unauthorized.
 * Listeners (e.g. AuthListener) should clear auth state and redirect to sign-in.
 */
export const AUTH_UNAUTHORIZED_EVENT = 'auth:unauthorized'

export function notifyUnauthorized(): void {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent(AUTH_UNAUTHORIZED_EVENT))
}
